import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import {cn} from '../lib/utils';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverArrow = PopoverPrimitive.Arrow;

export interface PopoverContentProps
  extends React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> {
  width?: 'same-as-trigger';
  portalled?: boolean;
}

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  PopoverContentProps
>(
  (
    {
      className,
      align = 'center',
      width,
      sideOffset = 4,
      portalled = true,
      ...props
    },
    ref,
  ) => {
    const Content = (
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 max-h-(--radix-popover-content-available-height) overflow-y-auto rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          width === 'same-as-trigger'
            ? 'w-(--radix-popover-trigger-width)'
            : 'w-72',
          className,
        )}
        {...props}
      />
    );

    if (portalled) {
      return <PopoverPrimitive.Portal>{Content}</PopoverPrimitive.Portal>;
    }

    return Content;
  },
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export {Popover, PopoverTrigger, PopoverContent, PopoverAnchor, PopoverArrow};
